import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { StudentContactInfoService } from './student-contact-info-service';
import { FormValidator } from "../form.validator";
import * as registrationStrings from "../stringFiles/registration.json";
import { commonFunctionService } from '../utils/commonFunctions';
import parsePhoneNumberFromString from 'libphonenumber-js/max';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { BrandService } from '../brand/brand.service';

declare let $: any;
declare let moment_js: any;
declare let customToastr: any;
@Component({
  selector: 'app-student-contact-info',
  templateUrl: './student-contact-info.component.html',
  styleUrls: ['./student-contact-info.component.css'],
  providers: [StudentContactInfoService, FormValidator]
})
export class StudentContactInfoComponent implements OnInit {
  strings: any;
  @Input() studentName: string;
  @Input() visible: string;
  @Input() studentId: string;
  @Input() academicId: string;
  @Input() button_text: string;
  @Input() schoolCurrency: string;
  @Output() save_button_event: EventEmitter<any> = new EventEmitter();
  @Output() closePopup: EventEmitter<any> = new EventEmitter();
  @ViewChild('editFatherMobileNumber', { static: false }) fatherContactInputRef!: ElementRef;
  @ViewChild('editMotherMobileNumber', { static: false }) motherContactInputRef!: ElementRef;
  @ViewChild('editGuardianMobileNumber', { static: false }) guardianContactInputRef!: ElementRef;

  profileIsLoading: boolean;
  studentData: any = {};
  debounceTimer: any;
  editSelectedFatherContactInput: string = ""
  invalidEditFatherMobileNumber = false;
  editSelectedFatherContact: string = ""
  editSelectedMotherContactInput: string = ""
  editSelectedMotherContact: string = ""
  invalidEditMotherMobileNumber = false;
  isMotherContactNumberChanged: boolean = false;
  isGuardianContactNumberChanged: boolean = false;
  editSelectedGuardianContactInput: string = "";
  editSelectedGuardianContact: string = "";
  invalidEditGuardianMobileNumber = false;
  brand = this.brandService.brand;

  /* Previews render immediately on selection; the actual File objects are
     held back and only uploaded (via updateParentsPicture) on Save, and only
     for whichever of the three actually changed. */
  fatherImagePreview: string | null = null;
  motherImagePreview: string | null = null;
  guardianImagePreview: string | null = null;
  fatherImageFile: File | null = null;
  motherImageFile: File | null = null;
  guardianImageFile: File | null = null;
  isSavingParentsPicture = false;
  pendingImageDeletions = new Set<string>();

  occupationList: any = [
    {
      name: 'Agriculture, Food and Natural Resources',
      value: 'Agriculture, Food and Natural Resources'
    },
    {
      name: 'Architecture and Construction',
      value: 'Architecture and Construction'
    },
    {
      name: "Arts, Audio/Video Technology and Communications",
      value: "Arts, Audio/Video Technology and Communications"
    },
    {
      name: "Business Management and Administration",
      value: "Business Management and Administration"
    },
    {
      name: "Education and Training",
      value: "Education and Training"
    },
    {
      name: "Finance",
      value: "Finance"
    },
    {
      name: "Government and Public Administration",
      value: "Government and Public Administration"
    },
    {
      name: "Health Science",
      value: "Health Science"
    },
    {
      name: "Hospitality and Tourism",
      value: "Hospitality and Tourism"
    },
    {
      name: "Human Services",
      value: "Human Services"
    },
    {
      name: "Information Technology",
      value: "Information Technology"
    },
    {
      name: "Law, Public Safety, Corrections and Security",
      value: "Law, Public Safety, Corrections and Security"
    },
    {
      name: "Manufacturing",
      value: "Manufacturing"
    },
    {
      name: "Marketing, Sales and Service",
      value: "Marketing, Sales and Service"
    },
    {
      name: "Science, Technology, Engineering and Mathematics",
      value: "Science, Technology, Engineering and Mathematics"
    },
    {
      name: "Transportation, Distribution and Logistics",
      value: "Transportation, Distribution and Logistics"
    },
    {
      name: "Others",
      value: "Others"
    }
  ];

  constructor(private studentContactInfoService: StudentContactInfoService, private formValidator: FormValidator, private commonFunction: commonFunctionService, private translate: TranslateService, private brandService: BrandService) {
    this.strings = registrationStrings
  }

  handleKeyDown(event: KeyboardEvent) {
    this.commonFunction.handleKeyDown(event);
  }

  ngOnInit() {
    this.isMotherContactNumberChanged = false;
    this.isGuardianContactNumberChanged = false;
    this.getStudentProfileDetails();
  }


  getStudentProfileDetails() {
    this.profileIsLoading = true;
    this.pendingImageDeletions.clear();
    this.studentContactInfoService.getStudentContactDetailsForEditForm(this.studentId, localStorage.getItem('usertoken')).subscribe(
      (data: any) => {
        this.profileIsLoading = false;
        this.studentData = JSON.parse(JSON.stringify(data.student));
        this.fatherImagePreview = this.studentData.fatherImage || null;
        this.motherImagePreview = this.studentData.motherImage || null;
        this.guardianImagePreview = this.studentData.guardianImage || null;
        this.editSelectedFatherContact = this.studentData.mobileNumber;
        this.editSelectedMotherContact = this.studentData.motherPhone;
        this.editSelectedGuardianContact = this.studentData.guardianPhone;
        this.studentData.motherCountryCode = this.studentData.motherCountryCode || this.brandService.brand.defaultCountryDialCode || '91';
        this.studentData.guardianCountryCode = this.studentData.guardianCountryCode || this.brandService.brand.defaultCountryDialCode || '91';
        this.studentData.countryCode = this.studentData.countryCode || this.brandService.brand.defaultCountryDialCode || '91';
        const countryData = this.getIntlTelInputGlobals().getCountryData();
        const matchedCountryForFather = countryData.find((country: any) => {
          return `${country.dialCode}` == this.studentData.countryCode;
        });
        const matchedCountryForMother = countryData.find((country: any) => {
          return `${country.dialCode}` == this.studentData.motherCountryCode;
        }); 
        const matchedCountryForGuardian = countryData.find((country: any) => {
          return `${country.dialCode}` == this.studentData.guardianCountryCode;
        }); 

        const fatherMobileNumberInput = $('#edit-student-father-mobile-number');
        fatherMobileNumberInput.intlTelInput({
          initialCountry: matchedCountryForFather.iso2,
          separateDialCode: false,
          autoPlaceholder: 'off',
          autoFormat: false,
          nationalMode: false,
          formatOnDisplay:false,
          allowDropdown: true,
          utilsScript:
            'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
        });

        const motherMobileNumberInput = $("#edit-student-mother-mobile-number")
        motherMobileNumberInput.intlTelInput({
          initialCountry: matchedCountryForMother.iso2,
          separateDialCode: false,
          autoPlaceholder: 'off',
          autoFormat: false,
          nationalMode: false,
          formatOnDisplay:false,
          allowDropdown: true,
          utilsScript:
            'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
        });

        const guardianMobileNumberInput = $("#edit-student-guardian-mobile-number")
        guardianMobileNumberInput.intlTelInput({
          initialCountry: matchedCountryForGuardian.iso2,
          separateDialCode: false,
          autoPlaceholder: 'off',
          autoFormat: false,
          nationalMode: false,
          formatOnDisplay:false,
          allowDropdown: true,
          utilsScript:
            'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js',
        });

        fatherMobileNumberInput.on('countrychange',()=>{
          fatherMobileNumberInput.val('');
          const countryData = fatherMobileNumberInput.intlTelInput("getSelectedCountryData");
          this.studentData.countryCode = countryData.dialCode;
        })
        
        motherMobileNumberInput.on('countrychange',()=>{
          motherMobileNumberInput.val('');
          const countryData = motherMobileNumberInput.intlTelInput("getSelectedCountryData");
          this.studentData.motherCountryCode = countryData.dialCode;
        })
        
        guardianMobileNumberInput.on('countrychange',()=>{
          guardianMobileNumberInput.val('');
          const countryData = guardianMobileNumberInput.intlTelInput("getSelectedCountryData");
          this.studentData.guardianCountryCode = countryData.dialCode;
        })
      },
      error => {
        this.profileIsLoading = false;
      }
    );
  }

  getIntlTelInputGlobals(): any {
    return (window as any).intlTelInputGlobals;
  }
  
  async save() {
    this.studentData.mobileNumber = this.editSelectedFatherContact;
    this.studentData.motherPhone = this.editSelectedMotherContact;
    if (this.editSelectedMotherContact && this.invalidEditMotherMobileNumber) {
     const pleaseEnterAValidStudentMotherMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidStudentMotherMobileNumber')); 
     customToastr(pleaseEnterAValidStudentMotherMobileNumberTranslation, 'error');
      return;
    }
    this.studentData.guardianPhone = this.editSelectedGuardianContact;
    if (this.editSelectedGuardianContact && this.invalidEditGuardianMobileNumber) {
      const pleaseEnterAValidStudentGuardianMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterAValidStudentGuardianMobileNumber')); 
      customToastr(pleaseEnterAValidStudentGuardianMobileNumberTranslation, 'error');
      return;
    }

    const excludedFieldsFromUpdate = ['isFatherImageAllowDelete', 'isMotherImageAllowDelete', 'isGuardianImageAllowDelete', 'defaultImageURL'];
    let finalStudent: any = {};
    for (let key in this.studentData) {
      if (this.studentData.hasOwnProperty(key) && !excludedFieldsFromUpdate.includes(key)) {
        finalStudent[key] = (this.formValidator.validateIsDataForNumber(this.studentData[key]) && this.studentData[key] !== 'null') ? this.studentData[key] : null;
      }
    }
    if (!finalStudent.parentName) {
      const pleaseProvideValidFatherNameTranslation = await firstValueFrom(this.translate.get('pleaseProvideValidFatherName')); 
      customToastr(pleaseProvideValidFatherNameTranslation, 'error');
      return;
    }
    
    this.editFatherMobileNumberValidator(this.fatherContactInputRef.nativeElement);
    if (!this.studentData.mobileNumber || this.invalidEditFatherMobileNumber) {
      const pleaseEnterValidFatherSMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherSMobileNumber')); 
      customToastr(pleaseEnterValidFatherSMobileNumberTranslation, 'error');
      return;
    }  

    if (this.studentData.motherPhone) {
      this.editMotherMobileNumberValidator(this.motherContactInputRef.nativeElement);
      if(this.invalidEditMotherMobileNumber) {
        const pleaseEnterValidMotherSMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMotherSMobileNumber')); 
        customToastr(pleaseEnterValidMotherSMobileNumberTranslation, 'error');
        return;
      }
    }

    if (this.studentData.guardianPhone) {
      this.editGuardianMobileNumberValidator(this.guardianContactInputRef.nativeElement);
      if(this.invalidEditGuardianMobileNumber) {
        const pleaseEnterValidGuardianSMobileNumberTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidGuardianSMobileNumber')); 
        customToastr(pleaseEnterValidGuardianSMobileNumberTranslation, 'error');
        return;
      }
    }
    const fatherPhoneIsvalid = this.formValidator.validateMobileNumberForNewAdmission(this.strings.father, this.studentData.mobileNumber);
    if (finalStudent.mobileNumber) {
      if (fatherPhoneIsvalid) {
        customToastr(fatherPhoneIsvalid, 'error');
        return;
      }
    }
    else {
      customToastr(fatherPhoneIsvalid, 'error');
      return
    }

    if (this.studentData.fatherPinCode && this.studentData.fatherPinCode.length < 6) {
      const pleaseEnterValidFatherPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidFatherPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    if (this.studentData.emailId) {
      const fatherEmailIsvalid = this.formValidator.validateIsEmail(this.studentData.emailId);
      if (!fatherEmailIsvalid) {
        const pleaseEnterValidFatherEmailTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidFatherEmail'));
        customToastr(pleaseEnterValidFatherEmailTranslation, 'error');
        return;
      }
    }

    if (this.studentData.motherEmail) {
      const motherEmailIsvalid = this.formValidator.validateIsEmail(this.studentData.motherEmail);
      if (!motherEmailIsvalid) {
        const pleaseEnterValidMotherEmailTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMotherEmail'));
        customToastr(pleaseEnterValidMotherEmailTranslation, 'error');
        return;
      }
    }

    if (this.studentData.motherPinCode && this.studentData.motherPinCode.length < 6) {
      const pleaseEnterValidMotherPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidMotherPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidMotherPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }

    if (this.studentData.guardianPinCode && this.studentData.guardianPinCode.length < 6) {
      const pleaseEnterValidGuardianPinCodeIsExactly6DigitsTranslation = await firstValueFrom(this.translate.get('pleaseEnterValidGuardianPinCodeIsExactly6Digits')); 
      customToastr(pleaseEnterValidGuardianPinCodeIsExactly6DigitsTranslation, 'error');
      return ;
    }
    if (!finalStudent.address) {
      const pleaseProvideFatherAddressTranslation = await firstValueFrom(this.translate.get('pleaseProvideFatherAddress')); 
      customToastr(pleaseProvideFatherAddressTranslation, 'error');
      return;
    }
    this.profileIsLoading = true;
    await this.saveParentsPictureIfChanged();
    this.studentContactInfoService.updateStudentDetails(finalStudent, localStorage.getItem('usertoken'))
      .subscribe(
        async (data: any) => {
          this.profileIsLoading = false;
          const contactInformationSuccessfullyUpdatedTranslation = await firstValueFrom(this.translate.get('contactInformationSuccessfullyUpdated'));
          customToastr(contactInformationSuccessfullyUpdatedTranslation, 'success');
          this.visible = 'none';
          this.save_button_event.emit();
        },
        async error => {
          this.profileIsLoading = false;
          const failedToUpdateContactInformationPleaseTryAgainTranslation = await firstValueFrom(this.translate.get('failedToUpdateContactInformationPleaseTryAgain'));
          customToastr(failedToUpdateContactInformationPleaseTryAgainTranslation, 'error');
        }
      )
  }

  close() {
    this.visible = 'none';
    this.closePopup.emit();
  }

  handleDebounceEditFatherMobileNumber(value: HTMLInputElement): void {
      this.editFatherMobileNumberValidator(value);
  }

  editFatherMobileNumberValidator(mobileNumberInput: HTMLInputElement): void {
    const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidEditFatherMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidEditFatherMobileNumber = !(isValid);
  }

  handleDebounceEditMotherMobileNumber(value: HTMLInputElement): void {
    this.isMotherContactNumberChanged = true;
      this.editMotherMobileNumberValidator(value);
      if (this.editSelectedMotherContact == "") {
        this.invalidEditMotherMobileNumber = false;
      }
  }

  editMotherMobileNumberValidator(mobileNumberInput: HTMLInputElement): void {
    const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidEditMotherMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidEditMotherMobileNumber = !(isValid);
  }

  handleDebounceEditGuardianMobileNumber(value: HTMLInputElement): void {
    this.isGuardianContactNumberChanged = true;
      this.editGuardianMobileNumberValidator(value);
      if (this.editSelectedGuardianContact == "") {
        this.invalidEditGuardianMobileNumber = false;
      }
  }

  editGuardianMobileNumberValidator(mobileNumberInput: HTMLInputElement): void {
    const fullNumber = $(mobileNumberInput).intlTelInput('getNumber');
    const phoneNumber = parsePhoneNumberFromString(fullNumber);
    if (!phoneNumber) {
      this.invalidEditGuardianMobileNumber = true;
      return;
    }
    const isValid = phoneNumber.isValid();
    this.invalidEditGuardianMobileNumber = !(isValid);
  }

  triggerContactImageUpload(inputId: string) {
    document.getElementById(inputId)?.click();
  }

  onContactImageSelected(event: any, which: 'father' | 'mother' | 'guardian') {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    if (!file.type || !file.type.startsWith('image/')) {
      customToastr('Please select a valid image file', 'error');
      event.target.value = '';
      return;
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      if (which === 'father') {
        this.fatherImagePreview = e.target.result;
        this.fatherImageFile = file;
      } else if (which === 'mother') {
        this.motherImagePreview = e.target.result;
        this.motherImageFile = file;
      } else {
        this.guardianImagePreview = e.target.result;
        this.guardianImageFile = file;
      }
      this.pendingImageDeletions.delete(which + 'Image');
    };
    reader.readAsDataURL(file);
    event.target.value = '';
  }

  /* Removal is local-only until Save — the actual deletePhotoType is sent
     together with any uploads in one call to updateParentsPicture. */
  removeContactImage(which: 'father' | 'mother' | 'guardian') {
    const photoTypeKey = which + 'Image';
    const defaultImageURL = this.studentData.defaultImageURL || null;
    if (which === 'father') {
      this.fatherImagePreview = defaultImageURL;
      this.fatherImageFile = null;
    } else if (which === 'mother') {
      this.motherImagePreview = defaultImageURL;
      this.motherImageFile = null;
    } else {
      this.guardianImagePreview = defaultImageURL;
      this.guardianImageFile = null;
    }
    if (this.studentData[photoTypeKey] && this.studentData[photoTypeKey] !== defaultImageURL) {
      this.pendingImageDeletions.add(photoTypeKey);
    }
  }

  /* Uploads/deletes whichever of father/mother/guardian pictures the user
     actually changed on this visit — untouched ones are left alone, matching
     the backend contract where each field is independently optional. */
  private saveParentsPictureIfChanged(): Promise<void> {
    if (!this.fatherImageFile && !this.motherImageFile && !this.guardianImageFile && this.pendingImageDeletions.size === 0) {
      return Promise.resolve();
    }
    this.isSavingParentsPicture = true;
    return new Promise((resolve) => {
      this.studentContactInfoService.updateParentsPicture(
        this.studentId,
        {
          fatherFile: this.fatherImageFile,
          motherFile: this.motherImageFile,
          guardianFile: this.guardianImageFile
        },
        Array.from(this.pendingImageDeletions),
        localStorage.getItem('usertoken')
      ).subscribe(
        (res: any) => {
          this.isSavingParentsPicture = false;
          const body = res && res.body ? res.body : {};
          if (body.fatherImage) {
            this.fatherImagePreview = body.fatherImage;
            this.studentData.fatherImage = body.fatherImage;
          }
          if (body.motherImage) {
            this.motherImagePreview = body.motherImage;
            this.studentData.motherImage = body.motherImage;
          }
          if (body.guardianImage) {
            this.guardianImagePreview = body.guardianImage;
            this.studentData.guardianImage = body.guardianImage;
          }
          this.fatherImageFile = null;
          this.motherImageFile = null;
          this.guardianImageFile = null;
          const defaultImageURL = this.studentData.defaultImageURL || null;
          this.pendingImageDeletions.forEach(photoTypeKey => {
            this.studentData[photoTypeKey] = defaultImageURL;
          });
          this.pendingImageDeletions.clear();
          resolve();
        },
        async () => {
          this.isSavingParentsPicture = false;
          const failMsg = await firstValueFrom(this.translate.get('failedToUpdateStudentPhoto'));
          customToastr(failMsg, 'error');
          resolve();
        }
      );
    });
  }
}